import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Button } from 'reactstrap'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import moment from 'moment'

pdfMake.vfs = pdfFonts.pdfMake.vfs

const { REACT_APP_BACKEND_URL } = process.env

// ── Helpers ───────────────────────────────────────────────────────────────────

const toBase64 = (url, headers = {}) =>
  fetch(url, { headers })
    .then((res) => res.blob())
    .then(
      (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror  = reject;
          reader.readAsDataURL(blob);
        })
    );

const formatName = (nama) => {
  if (!nama) return null
  if (nama.length <= 15) {
    return nama.split(' ').map((w) => (w ? w[0].toUpperCase() + w.slice(1) : '')).join(' ')
  }
  return (
    nama.slice(0, 13).split(' ').map((w) => (w ? w[0].toUpperCase() + w.slice(1) : '')).join(' ') + '.'
  )
}

const buildApprovalHeader = (label, colSpan = 1) => ({
  text:      label,
  bold:      true,
  alignment: 'center',
  fontSize:  7,
  border:    [true, true, true, true],
  fillColor: '#f2f2f2',
  margin:    [2, 3, 2, 3],
  colSpan,
})

const buildApprovalBody = (item) => {
  const border = [true, true, true, true]

  if (!item) {
    return {
      stack:  [{ text: '\n\n-\n\n-', alignment: 'center', fontSize: 7 }],
      border,
      margin: [2, 4, 2, 4],
    }
  }

  const name    = formatName(item.nama)
  const date    = moment(item.updatedAt).format('DD/MM/YYYY')
  const status  = item.status === 0 ? `Reject (${date})` : `Approve (${date})`
  const jabatan = item.jabatan ? item.jabatan.toUpperCase() : '-'

  return {
    stack: [
      { text: status,      alignment: 'center', fontSize: 6, margin: [0, 4, 0, 0] },
      { text: '\n' },
      { text: name || '-', alignment: 'center', fontSize: 7 },
      { text: jabatan,     alignment: 'center', fontSize: 6 },
    ],
    border,
    margin: [2, 4, 2, 4],
  }
}

// ─────────────────────────────────────────────────────────────────────────────

class FormMutasi extends Component {

  downloadForm = async () => {
    // ── Ambil data dari props (sama persis seperti Excel) ─────────────────────
    const { dataMut, noMut, mutApp, dataDoc, detailMut, infoApp } = this.props.mutasi

    // ── Parse matrix otorisasi ────────────────────────────────────────────────
    const splitApp     = infoApp.info ? infoApp.info.split(']') : []
    const pembuatApp   = splitApp.length > 0 ? splitApp[0] : ''
    const pemeriksaApp = splitApp.length > 0 ? splitApp[1] : ''
    const penyetujuApp = splitApp.length > 0 ? splitApp[2] : ''

    // ── Logo ──────────────────────────────────────────────────────────────────
    let logoBase64 = null
    try {
      const token = localStorage.getItem('token')

      logoBase64 = await toBase64(
        `${REACT_APP_BACKEND_URL}/masters/logo.png`,
        { Authorization: `Bearer ${token}` }
      )
    } catch (e) {
      console.warn('Logo gagal dimuat:', e)
    }

    // ── Info header ───────────────────────────────────────────────────────────
    const firstDetail   = detailMut?.[0]
    const noMutasi      = firstDetail ? firstDetail.no_mutasi      : ''
    const tanggalMut    = firstDetail ? moment(firstDetail.tanggalMut).format('DD MMMM YYYY') : ''
    const tglMutasiFisik = firstDetail && firstDetail.tgl_mutasifisik
      ? moment(firstDetail.tgl_mutasifisik).format('DD MMMM YYYY')
      : ''
    const areaMut       = firstDetail ? firstDetail.area           : ''
    const alasan        = firstDetail && firstDetail.alasan !== null ? firstDetail.alasan : ''
    const isStatusForm8 = firstDetail && firstDetail.status_form === 8

    // ── Approval lists ────────────────────────────────────────────────────────
    // Mutasi: Dibuat + Diterima + Diperiksa + Disetujui
    const buatList    = mutApp?.pembuat   ? [...mutApp.pembuat]   : []
    const terimaList  = mutApp?.penerima  ? [...mutApp.penerima]  : []
    const periksaList = mutApp?.pemeriksa ? mutApp.pemeriksa.filter((x) => x.status_view !== 'hidden') : []
    const setujuList  = mutApp?.penyetuju ? [...mutApp.penyetuju] : []

    if (!buatList.length)   buatList.push(null)
    if (!terimaList.length) terimaList.push(null)
    if (!periksaList.length) periksaList.push(null)
    if (!setujuList.length) setujuList.push(null)

    const totalCols      = buatList.length + terimaList.length + periksaList.length + setujuList.length
    const approvalWidths = Array(totalCols).fill('*')

    // Row 1: group header dengan colSpan
    const approvalHeaderRow = [
      { ...buildApprovalHeader('Dibuat oleh,', buatList.length) },
      ...Array(buatList.length - 1).fill({ text: '', border: [false, false, false, false] }),
      { ...buildApprovalHeader('Diterima oleh,', terimaList.length) },
      ...Array(terimaList.length - 1).fill({ text: '', border: [false, false, false, false] }),
      { ...buildApprovalHeader('Diperiksa oleh,', periksaList.length) },
      ...Array(periksaList.length - 1).fill({ text: '', border: [false, false, false, false] }),
      { ...buildApprovalHeader('Disetujui oleh,', setujuList.length) },
      ...Array(setujuList.length - 1).fill({ text: '', border: [false, false, false, false] }),
    ]

    // Row 2: isi nama, status, jabatan per orang
    const approvalBodyRow = [
      ...buatList.map((item)   => buildApprovalBody(item)),
      ...terimaList.map((item) => buildApprovalBody(item)),
      ...periksaList.map((item) => buildApprovalBody(item)),
      ...setujuList.map((item) => buildApprovalBody(item)),
    ]

    // ── Tabel aset ────────────────────────────────────────────────────────────
    // Kolom: No Asset | Nama Asset | Type/Merk | Kategori | CC Lama (Cabang+CC) | CC Baru (Cabang+CC)
    const itemHeader = [
      [
        { text: 'No. Asset /\nNo. Inventaris', bold: true, alignment: 'center', fillColor: '#f2f2f2', border: [true,true,true,true], fontSize: 7, rowSpan: 2 },
        { text: 'Nama Asset / Inventaris',    bold: true, alignment: 'center', fillColor: '#f2f2f2', border: [true,true,true,true], fontSize: 7, rowSpan: 2 },
        { text: 'Type / Merk',                bold: true, alignment: 'center', fillColor: '#f2f2f2', border: [true,true,true,true], fontSize: 7, rowSpan: 2 },
        { text: 'Kategori\n(Aset/Inventaris)', bold: true, alignment: 'center', fillColor: '#f2f2f2', border: [true,true,true,true], fontSize: 7, rowSpan: 2 },
        { text: 'Cost Center Lama',           bold: true, alignment: 'center', fillColor: '#f2f2f2', border: [true,true,true,true], fontSize: 7, colSpan: 2 },
        { text: '',                                                             border: [false,false,false,false], fontSize: 7 },
        { text: 'Cost Center Baru',           bold: true, alignment: 'center', fillColor: '#f2f2f2', border: [true,true,true,true], fontSize: 7, colSpan: 2 },
        { text: '',                                                             border: [false,false,false,false], fontSize: 7 },
      ],
      [
        // rowSpan placeholders
        { text: '', border: [false,false,false,false], fontSize: 7 },
        { text: '', border: [false,false,false,false], fontSize: 7 },
        { text: '', border: [false,false,false,false], fontSize: 7 },
        { text: '', border: [false,false,false,false], fontSize: 7 },
        { text: 'Cabang / Depo', bold: true, alignment: 'center', fillColor: '#f2f2f2', border: [true,true,true,true], fontSize: 7 },
        { text: 'Cost Center',   bold: true, alignment: 'center', fillColor: '#f2f2f2', border: [true,true,true,true], fontSize: 7 },
        { text: 'Cabang / Depo', bold: true, alignment: 'center', fillColor: '#f2f2f2', border: [true,true,true,true], fontSize: 7 },
        { text: 'Cost Center',   bold: true, alignment: 'center', fillColor: '#f2f2f2', border: [true,true,true,true], fontSize: 7 },
      ],
    ]

    const itemRows = (detailMut || []).map((item) => [
      { text: `${item.no_asset}`,                              alignment: 'center', border: [true,true,true,true], fontSize: 7 },
      { text: `${item.nama_asset}`,                            alignment: 'center', border: [true,true,true,true], fontSize: 7 },
      { text: item.merk === null ? '-' : `${item.merk}`,      alignment: 'center', border: [true,true,true,true], fontSize: 7 },
      { text: item.kategori ? `${item.kategori}` : '-',        alignment: 'center', border: [true,true,true,true], fontSize: 7 },
      { text: `${item.area}`,                                  alignment: 'center', border: [true,true,true,true], fontSize: 7 },
      { text: `${item.cost_center}`,                           alignment: 'center', border: [true,true,true,true], fontSize: 7 },
      { text: `${item.area_rec}`,                              alignment: 'center', border: [true,true,true,true], fontSize: 7 },
      { text: `${item.cost_center_rec}`,                       alignment: 'center', border: [true,true,true,true], fontSize: 7 },
    ])

    // ── Box DITERIMA + EKSEKUSI SAP (hanya jika status_form === 8) ────────────
    let docSap = ''
    if (isStatusForm8) {
      for (let x = 0; x < detailMut.length; x++) {
        if (detailMut[x].doc_sap !== null) {
          docSap += detailMut[x].doc_sap + (x !== detailMut.length - 1 ? ', ' : '')
        }
      }
    }

    const tglMutasiSap = isStatusForm8 && firstDetail
      ? moment(firstDetail.tgl_mutasisap).format('DD/MM/YYYY')
      : '-'
    const picAset = isStatusForm8 && firstDetail ? firstDetail.pic_aset : '-'

    // ── Doc definition ────────────────────────────────────────────────────────
    const docDefinition = {
      pageSize:        'A4',
      pageOrientation: 'landscape',
      pageMargins:     [25, 25, 25, 30],

      footer: (currentPage, pageCount) => ({
        text:      `Halaman ${currentPage} dari ${pageCount}`,
        alignment: 'center',
        fontSize:  7,
        margin:    [0, 8, 0, 0],
      }),

      content: [

        // ── Header: Logo (kiri) + Judul (tengah) + Info form (kanan) ──────────
        {
          table: {
            widths: [55, '*', 210],
            heights: [70],
            body: [[
              // Kiri: logo
              logoBase64
                ? { image: logoBase64, width: 45, height: 60, alignment: 'center', border: [true,true,true,true], margin: [2, 4, 2, 4] }
                : { text: '', border: [true,true,true,true] },

              // Tengah: judul
              {
                text:      'FORM MUTASI ASSET / INVENTARIS',
                bold:      true,
                fontSize:  12,
                decoration:'underline',
                alignment: 'center',
                border:    [true, true, true, true],
                margin:    [0, 24, 0, 0],
              },

              // Kanan: info form — 4 baris label + value
              {
                border: [true, true, true, true],
                margin: [4, 6, 4, 6],
                stack: [
                  {
                    columns: [
                      { text: 'No.',                  width: 90, fontSize: 8 },
                      { text: `: ${noMutasi}`,        fontSize: 8, width: '*' },
                    ],
                    margin: [0, 0, 0, 4],
                  },
                  {
                    columns: [
                      { text: 'Tanggal Form',         width: 90, fontSize: 8 },
                      { text: `: ${tanggalMut}`,      fontSize: 8, width: '*' },
                    ],
                    margin: [0, 0, 0, 4],
                  },
                  {
                    columns: [
                      { text: 'Tanggal Mutasi Fisik', width: 90, fontSize: 8 },
                      { text: `: ${tglMutasiFisik}`,  fontSize: 8, width: '*' },
                    ],
                    margin: [0, 0, 0, 4],
                  },
                  {
                    columns: [
                      { text: 'Cabang / Depo',        width: 90, fontSize: 8 },
                      { text: `: ${areaMut}`,         fontSize: 8, width: '*' },
                    ],
                  },
                ],
              },
            ]],
          },
          layout: { hLineWidth: () => 0.5, vLineWidth: () => 0.5 },
          margin: [0, 0, 0, 10],
        },

        // ── Tabel Detail Aset ─────────────────────────────────────────────────
        {
          table: {
            headerRows: 2,
            widths:     [55, '*', 50, 50, 55, 45, 55, 45],
            body:       [...itemHeader, ...itemRows],
          },
          layout: { hLineWidth: () => 0.5, vLineWidth: () => 0.5 },
          margin: [0, 0, 0, 10],
        },

        // ── Alasan Mutasi + Matrix Otorisasi (berdampingan) ───────────────────
        {
          columns: [
            // Kiri: box Alasan Mutasi
            {
              table: {
                widths: ['*'],
                body: [
                  [{ text: 'Alasan Mutasi :', bold: true, decoration: 'underline', fontSize: 8, border: [true,true,true,false], margin: [2,2,2,0] }],
                  [{ text: alasan,             fontSize: 8, border: [true,false,true,true], margin: [2,4,2,30] }],
                ],
              },
              layout: { hLineWidth: () => 0.5, vLineWidth: () => 0.5 },
              width: 160,
            },
            { text: '', width: 10 }, // spacer
            // Kanan: Matrix Otorisasi
            {
              stack: [
                { text: 'Matrix Otorisasi, ditandatangani oleh :', bold: true, decoration: 'underline', fontSize: 7 },
                {
                  columns: [
                    {
                      stack: [
                        { text: 'Area ke Area',                                                          bold: true, fontSize: 7, margin: [0, 4, 0, 2] },
                        { text: `1. Dibuat     : ${pembuatApp.split(';')[4]   || ''}`,                   fontSize: 7 },
                        { text: `2. Diperiksa  : ${pemeriksaApp.split(';')[4] || ''}`,                   fontSize: 7, margin: [0, 2, 0, 0] },
                        { text: `3. Disetujui  : ${penyetujuApp.split(';')[4] || ''}`,                   fontSize: 7, margin: [0, 2, 0, 0] },
                      ],
                    },
                    {
                      stack: [
                        { text: 'HO ke Area',                                                            bold: true, fontSize: 7, margin: [0, 4, 0, 2] },
                        { text: `1. Dibuat     : ${pembuatApp.split(';')[2]   || ''}`,                   fontSize: 7 },
                        { text: `2. Diperiksa  : ${pemeriksaApp.split(';')[2] || ''}`,                   fontSize: 7, margin: [0, 2, 0, 0] },
                        { text: `3. Disetujui  : ${penyetujuApp.split(';')[2] || ''}`,                   fontSize: 7, margin: [0, 2, 0, 0] },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
          margin: [0, 0, 0, 10],
        },

        // ── Tabel Approval ────────────────────────────────────────────────────
        {
          table: {
            widths: approvalWidths,
            body:   [approvalHeaderRow, approvalBodyRow],
          },
          layout: { hLineWidth: () => 0.5, vLineWidth: () => 0.5 },
          margin: [0, 0, 0, 10],
        },

        // ── Nomor Form ────────────────────────────────────────────────────────
        { text: 'FRM-HCD-104 REV 07', fontSize: 7, margin: [0, 0, 0, isStatusForm8 ? 8 : 0] },

        // ── Box DITERIMA ASSET + EKSEKUSI SAP (hanya jika status_form === 8) ──
        ...(isStatusForm8 ? [
          {
            columns: [
              { text: '', width: '*' }, // spacer kiri
              {
                table: {
                  widths: [130, 130],
                  body: [[
                    {
                      stack: [
                        { text: 'DITERIMA ASSET PMA HO', bold: true, alignment: 'center', fontSize: 8 },
                        { text: '\n' },
                        { text: tglMutasiSap,             alignment: 'center', fontSize: 8 },
                        { text: `PENERIMA: ${picAset}`,   alignment: 'center', fontSize: 8 },
                      ],
                      border:  [true,true,true,true],
                      margin:  [4, 8, 4, 8],
                    },
                    {
                      stack: [
                        { text: 'EKSEKUSI DI SAP',       bold: true, alignment: 'center', fontSize: 8 },
                        { text: '\n' },
                        { text: tglMutasiSap,             alignment: 'center', fontSize: 8 },
                        { text: `NO. DOC: ${docSap}`,     alignment: 'center', fontSize: 8 },
                        { text: `PENCATAT: ${picAset}`,   alignment: 'center', fontSize: 8 },
                      ],
                      border:  [true,true,true,true],
                      margin:  [4, 8, 4, 8],
                    },
                  ]],
                },
                layout: { hLineWidth: () => 0.5, vLineWidth: () => 0.5 },
                width:  'auto',
              },
            ],
          },
        ] : []),
      ],

      defaultStyle: {
        fontSize: 8,
        font:     'Roboto',
      },
    }

    const fileName = `Form Mutasi Asset ${firstDetail?.no_mutasi ?? ''} ${moment().format('DD MMMM YYYY')}.pdf`

    return new Promise((resolve, reject) => {
      try {
        pdfMake.createPdf(docDefinition).download(fileName, () => resolve(fileName))
      } catch (err) {
        reject(err)
      }
    })
  }

  render() {
    return (
      <Button className='ml-2' color="info" onClick={this.downloadForm}>
        Download Form PDF
      </Button>
    )
  }
}

const mapStateToProps = (state) => ({
  asset:    state.asset,
  depo:     state.depo,
  mutasi:   state.mutasi,
  user:     state.user,
  tempmail: state.tempmail,
  newnotif: state.newnotif,
  dokumen:  state.dokumen,
})

export default connect(mapStateToProps)(FormMutasi)